import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominasNominaDocumentosCfdiGeneradorItem', {
    template: template,
    controller: NominasNominaDocumentosCfdiGeneradorItemComponent,
    bindings: {
      data: '<',
      onChange: '&',
    },
  })

function NominasNominaDocumentosCfdiGeneradorItemComponent($http, $q, $timeout, $window, $zip) {
  let $ctrl = this

  $ctrl.$onInit = $onInit
  $ctrl.$onDestroy = $onDestroy
  $ctrl.descargar = descargar
  $ctrl.generar = generar
  $ctrl.repetir = repetir

  function $onInit() {
    if (!$ctrl.data.completado)
      generar()
  }

  function $onDestroy() {
    if ($ctrl.timeout)
      $ctrl.timeout.resolve()
  }

  function generar() {
    $ctrl.data.documentos = null
    $ctrl.data.error = null
    $ctrl.timeout = $q.defer()

    $http.get('/api/nominas/nomina/colaboradores/colaborador/documentos/cfdi', {
        params: {
          id_proyecto: $ctrl.data.id_proyecto,
          id_nomina: $ctrl.data.id_nomina,
          id_colaborador: $ctrl.data.id_colaborador,
          generar_pdf: $ctrl.data.opciones.generar_pdf ? 1 : 0,
          generar_xml: $ctrl.data.opciones.generar_xml ? 1 : 0,
          enviar_email: $ctrl.data.opciones.enviar_email ? 1 : 0,
          pdf_dual: $ctrl.data.opciones.pdf_dual ? 1 : 0,
        },
        schema: {
          generar_pdf: 'boolean',
          generar_xml: 'boolean',
          enviar_email: 'boolean',
          pdf_dual: 'boolean',
        },
        timeout: $ctrl.timeout.promise,
        responseType: 'blob',
      })
      .then(completado)
      .catch(error)
      .finally(function () {
        $ctrl.data.opciones.enviar_email = false
        $ctrl.data.completado = true

        $ctrl.onChange({$event: {data: $ctrl.data}})
      })
  }

  function completado(response) {
    $ctrl.data.email_enviado = $ctrl.data.opciones.enviar_email

    if (response.headers('Content-Type').indexOf('application/zip') < 0) {
      $ctrl.data.documentos = []

      return
    }

    return $zip().then(function (zip) {
      return zip.loadAsync(response.data).then(function (contents) {
        let promises = []

        angular.forEach(contents.files, function (file, filename) {
          if ($ctrl.data.opciones.agrupar_area) {
            filename = $ctrl.data.area + '/' + filename
          }

          if ($ctrl.data.opciones.agrupar_departamento) {
            filename = $ctrl.data.departamento + '/' + filename
          }

          promises.push(convertir(file, filename))
        })

        return $q.all(promises)
          .then(function (docs) {
            $ctrl.data.documentos = docs
          })
      })
    })
  }

  function descargar(documento) {
    let file = new Blob([documento.content], {type: documento.contentType}),
      url = $window.URL.createObjectURL(file),
      window = $window.open(url, 'nomina_documentos_cfdi')

    if (window) {
      window.focus()
    }

    $timeout(function () {
      $window.URL.revokeObjectURL(url)
    }, 3000)
  }

  function error() {
    $ctrl.data.error = 'Se generó un error'
  }

  function convertir(file, filename) {
    return file.async('blob')
      .then(function (content) {
        let ext = filename.substr(filename.lastIndexOf('.') + 1)

        return {
          ext: ext.toUpperCase(),
          filename: filename,
          content: content,
          contentType: ext === 'pdf' ? 'application/pdf' : 'application/xml',
        }
      })
  }

  function repetir() {
    $ctrl.data.completado = false
    generar()
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/documentos/cfdi/generador/item/component.js